import React, { useState } from 'react';
import pluralize from 'pluralize';
import moment from 'moment';
import classnames from 'classnames';
import { useUrlDataContext } from '../lib/UrlDataContext';
import { IoSearchOutline, IoTimeOutline } from 'react-icons/io5';
import Loader from '../../General/Loader';
import { getShopProductUrl } from '../../../helpers/helpers';
import './Header.scss';

const HeaderText = ({ totalCount, loading, filters }) => {
  if (totalCount > 0) {
    if (filters.domain) {
      return `${totalCount} unmatched ${filters.showEscalated ? 'escalated ' : ''} URLs on ${filters.domain}`;
    }

    return `${totalCount} unmatched ${filters.showEscalated ? 'escalated ' : ''} URLs`;
  }

  if (loading) {
    return 'Finding unmatched URLs...';
  }

  if (filters.domain) {
    return `No unmatched ${filters.showEscalated ? 'escalated ' : ''} URLs found for ${filters.domain}`;
  }

  return `No unmatched ${filters.showEscalated ? 'escalated ' : ''} URLs found`;
};

export const Header = ({ onSearchPressed }) => {
  const { totalCount, loading, filters, matches, history, resetFilters, excludedDomains, hiddenByExclusions, clearExcludedDomains } = useUrlDataContext();
  const [showHistory, setShowHistory] = useState(false);

  const canClearFilters = Object.entries(filters).some(([filter, value]) => value !== null);

  return (
    <header className='url-data-header'>
      <button className='search-button' onClick={onSearchPressed}>
        <IoSearchOutline size={20} />
      </button>

      <div className='title'>
        <HeaderText totalCount={totalCount} loading={loading} filters={filters} />
        {canClearFilters && (
          <button className='clear-filter' onClick={resetFilters}>
            clear filters
          </button>
        )}
        {excludedDomains.length > 0 && (
          <div className='excluded-domains-banner'>
            {pluralize('domain', excludedDomains.length, true)} hidden ({pluralize('URL', hiddenByExclusions, true)})
            <button className='clear-filter' onClick={clearExcludedDomains}>
              show all
            </button>
          </div>
        )}
      </div>

      <div className='matches-container'>
        {matches.size > 0 && (
          <div className='matches'>
            <Loader variant='circle' className='loading-icon' size={12} /> Saving {matches.size} {pluralize('match', matches.size)}
          </div>
        )}

        {history.length > 0 && (
          <>
            <div className='history-summary'>{history.length} matched today</div>

            <div className='history-popover-container'>
              <button className={classnames('history-button', { active: showHistory })} onClick={() => setShowHistory(prev => !prev)}>
                <IoTimeOutline size={20} />
              </button>

              {showHistory && (
                <ul className='history-popover'>
                  {history.map(item => (
                    <li key={item.id}>
                      <a className='product' href={getShopProductUrl(item.productId)} target='_blank' rel='noopener noreferrer'>
                        {item.brandName} {item.productTitle}
                      </a>

                      <div className='actions'>
                        <div className='date'>{moment.utc(item.matchedAt).fromNow()}</div>
                        <a href={`/url-data?hashedUrlStem=${item.hashedUrlStem}`} target='_blank' rel='noopener noreferrer'>
                          Edit
                        </a>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </>
        )}
      </div>

      {showHistory && <button className='popover-closer' onClick={() => setShowHistory(false)} />}
    </header>
  );
};
